const map = {
	"./assets/images/UIV5/device.webp": 7402,
	"./assets/images/UIV5/device1.png": 1420,
	"./assets/images/UIV5/device2.png": 5351,
	"./assets/images/UIV5/device3.png": 5854,
	"./assets/images/UIV5/device4.png": 4337,
	"./assets/images/UIV5/moduleCabinet.png": 1199,
	"./assets/images/UIV5/system.png": 940,
	"./assets/images/bg/aiBg.png": 332,
	"./assets/images/bg/aiBg2.png": 132,
	"./assets/images/bg/banner.png": 1197,
	"./assets/images/bg/concatUs.png": 1299,
	"./assets/images/bg/customBg.png": 3835,
	"./assets/images/bg/developmentHistory.png": 5118,
	"./assets/images/bg/ecosystem.png": 4903,
	"./assets/images/bg/history.png": 6687,
	"./assets/images/bg/indoorDangerBgc.png": 1115,
	"./assets/images/bg/labAiBg.png": 5433,
	"./assets/images/bg/labBanner.png": 8180,
	"./assets/images/bg/labInfoBg.png": 4819,
	"./assets/images/bg/outDanger3.png": 8451,
	"./assets/images/bg/outDangerBg.png": 3135,
	"./assets/images/bg/pdtAiArrow.png": 7254,
	"./assets/images/bg/pdtHard6.png": 924,
	"./assets/images/bg/planBg.png": 3232,
	"./assets/images/bg/processBg.png": 541,
	"./assets/images/bg/waterBg.png": 5319,
	"./assets/images/bg/wiseBg.png": 2542,
	"./assets/images/cooperativeEcosystem/company1.webp": 8707,
	"./assets/images/cooperativeEcosystem/company2.webp": 4173,
	"./assets/images/cooperativeEcosystem/company3.webp": 1154,
	"./assets/images/cooperativeEcosystem/company4.webp": 6495,
	"./assets/images/cooperativeEcosystem/company5.webp": 4956,
	"./assets/images/cooperativeEcosystem/company6.webp": 233,
	"./assets/images/cooperativeEcosystem/company7.webp": 9342,
	"./assets/images/cooperativeEcosystem/company8.webp": 5499,
	"./assets/images/cooperativeEcosystem/company9.webp": 1256,
	"./assets/images/icon/bar.png": 4274,
	"./assets/images/icon/battery.png": 434,
	"./assets/images/icon/blackCustom.png": 2993,
	"./assets/images/icon/box.png": 2873,
	"./assets/images/icon/code.png": 2318,
	"./assets/images/icon/cpu.png": 8775,
	"./assets/images/icon/diamond.png": 7677,
	"./assets/images/icon/folding-portable.png": 5672,
	"./assets/images/icon/high-precision.png": 7878,
	"./assets/images/icon/home.png": 1108,
	"./assets/images/icon/integrated-hardware.png": 1153,
	"./assets/images/icon/lifecycle-management.png": 2669,
	"./assets/images/icon/linked-control.png": 3336,
	"./assets/images/icon/list.png": 7721,
	"./assets/images/icon/loc.png": 8847,
	"./assets/images/icon/module.png": 217,
	"./assets/images/icon/mul.png": 9439,
	"./assets/images/icon/robot.png": 1361,
	"./assets/images/icon/scan.png": 9750,
	"./assets/images/icon/synchro.png": 9436,
	"./assets/images/icon/system.png": 3882,
	"./assets/images/icon/tag.png": 9853,
	"./assets/images/icon/traceability-query.png": 8505,
	"./assets/images/icon/whiteCustom.png": 111,
	"./assets/images/icon/wifi.png": 9158,
	"./assets/images/qrCode.jpg": 1701,
	"./assets/images/qrCode2.jpg": 9243,
	"./assets/images/qrCode3.png": 8938,
	"./assets/style/index.scss": 4425,
	"./assets/style/variable.scss": 1711
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7734;